import { createRouter, createWebHistory } from 'vue-router'
import AuroraView from '../views/AuroraView.vue'
import AboutView from '../views/AboutView.vue'
import ExploreView from '../views/ExploreView.vue'
import SurveyView from '@/views/SurveyView.vue'
import AdminView from '../views/AdminView.vue'
import LoginView from '../views/LoginView.vue'
import SignUpView from '../views/SignUpView.vue'
import HomeView from '../views/HomeView.vue'
import SettingsView from '../views/SettingsView.vue'

const routes = [
  {
    path: '/viewer',
    name: 'aurora',
    component: AuroraView
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView
  },
  {
    path: '/explore',
    name: 'explore',
    component: ExploreView
  },
    {
    path: '/survey',
    name: 'survey',
    component: SurveyView
  },
  {
    path: '/settings',
    name: 'settings',
    component: SettingsView
  },
    {
    path: '/admin',
    name: 'admin',
    component: AdminView
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/signup',
    name: 'signup',
    component: SignUpView
  },
  {
    path: '/',
    name: 'index',
    component: HomeView
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
